import apiClient from './client';
import { API_ENDPOINTS } from './config';
import type { InvoiceListResponse, SendInvoiceRequest } from '../types/invoice';

export const invoiceApi = {
	getList: async (locationId?: number): Promise<InvoiceListResponse> => {
		const query = locationId ? `?locationId=${locationId}` : '';
		return apiClient.get<InvoiceListResponse>(`${API_ENDPOINTS.INVOICE.LIST}${query}`);
	},

	send: async (data: SendInvoiceRequest): Promise<void> => {
		return apiClient.post(API_ENDPOINTS.INVOICE.SEND, data);
	},
};
